import { Typography } from "@aircall/tractor";

import { ButtonLinkProps } from "./ButtonLink.decl";
import * as S from "./ButtonLink.styled";

export function ButtonLink({
  children,
  onClick,
  href,
  target = "_self",
  "data-test": dataTest = "button-link",
  ...buttonProps
}: ButtonLinkProps) {
  return (
    <S.StyledButton
      onClick={onClick}
      data-test={dataTest}
      as="a"
      href={href}
      target={target}
      {...buttonProps}
    >
      <Typography variant="bodySemiboldM">{children}</Typography>
    </S.StyledButton>
  );
}
